module.exports = "/_next/static/images/UnlockYourFullPotential-bf59eda53f318ae1ac35744e6ce5cf32.webp";